export enum AddressType {
  Company, Resident,
}
